export default {
  ErrorPage__BODY_PART1: "If you have logged in, feel free to",
  ErrorPage__BODY_PART2: "browse the web.",
  ErrorPage__BODY_PART3:
    "If you have not logged in, please refresh this page again in a few minutes.",
  ErrorPage__HEADING: "Sorry, our inflight homepage is unavailable.",
};
